
export const EVENTS = {
  RESIZE: 'resize',
  CHANGE: 'change',
  OFF: 'off',
  ON: 'on',
  UPDATE: 'update',
  ERROR: 'error'
}
